<template>
    <div class="page">
        <div class="header">
            <img class="logo"
                src="https://yujie-bio.oss-cn-hangzhou.aliyuncs.com/2026/01/08/9cc7f0f4ac4b43b7a42b67eafb53f254.png">
            <img class="companyName"
                src="https://yujie-bio.oss-cn-hangzhou.aliyuncs.com/2026/02/03/7061dc54da1d48c58e335224e9ae0432.png">
            <div style="flex: 1;"></div>
            <div class="navbar">
                <div class="navbarItem" v-for="(item, index) in navbar" :key="index"
                    @click="scrollToAnchor(item.anchorId)">{{
                        item.name }}
                </div>
            </div>
        </div>
        <div class="option">
            <el-breadcrumb separator="/" :replace="true">
                <el-breadcrumb-item :to="{ path: '/' }" :replace="true">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/ProductCenter' }" :replace="true">产品中心</el-breadcrumb-item>
                <el-breadcrumb-item>产品详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="detail" ref="detail" :style="{ 'height': height + 'px' }">
            <div class="infoBox">
                <div class="infoBoxLeft">
                    <img :src="form.coverImages[imgIndex]" class="nowImg">
                </div>
                <div class="infoBoxRight" ref="infoBoxRight">
                    <div class="pName">{{ form.name }}</div>
                    <div class="pNum">货号:
                        <span>{{ form.productNo }}</span>
                    </div>
                    <!-- <div class="price">¥{{ form.price }}</div>
                    <div class="spec">
                        <div class="title">产品规格</div>
                        <div class="specTxt">{{ form.specification }}</div>
                    </div> -->
                    <div class="skuList" v-if="form.skuList && form.skuList.length > 0">
                        <div class="skuHeader">
                            <div>规格</div>
                            <div>价格</div>
                            <div>库存</div>
                        </div>
                        <div class="skuCol" v-for="(item, index) in form.skuList">
                            <div>{{ item.value1 }}</div>
                            <div>￥{{ item.value2 }}</div>
                            <div>{{ item.value3 }}</div>
                        </div>
                    </div>
                    <div class="imgList" v-if="form.coverImages" :style="{ 'max-width': width + 'px' }">
                        <img v-for="(item, index) in form.coverImages" @click="changeImg(item, index)" :key="index"
                            :src="item" :class="['imgItem', { 'imgItemActive': index == imgIndex }]">
                    </div>
                    <div class="btn" @click="copy()">一键复制产品信息</div>
                </div>
            </div>
            <div class="mainTitle">产品介绍</div>
            <div class="productContent" v-html="form.detail"></div>
        </div>
    </div>
</template>
<script>
import { productDetail } from '../api.js';
export default {
    data() {
        return {
            height: 0,
            width: 0,
            imgIndex: 0,
            form: {
                coverImages: []
            },
            id: null,
            navbar: [
                { name: '首页', anchorId: 'section1' },
                { name: '产品中心', anchorId: 'section2' },
                { name: '代理品牌', anchorId: 'section3' },
                { name: '关于我们', anchorId: 'section4' },
                { name: '联系我们', anchorId: 'section5' }
            ],
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.getElementHeight()
        })
        this.id = this.$route.query.id
        this.getDetail()
    },
    methods: {
        scrollToAnchor(anchorId) {
            this.$router.replace({
                path: '/',
                query: {
                    anchorId: anchorId
                }
            })
        },
        getDetail() {
            productDetail(this.id).then(res => {
                if (res.code === 0) {
                    this.form = res.data
                    this.form.skuList = res.data.skuList ? JSON.parse(res.data.skuList) : []
                }
            })
        },
        getCopyInfo(type) {
            let arr = []
            if (type == 'specification') {
                this.form.skuList.forEach(item => {
                    arr.push(item.value1)
                })
            } else if (type == 'price') {
                this.form.skuList.forEach(item => {
                    arr.push(`¥${item.value2}`)
                })
            }
            return arr.join('、')
        },
        copy() {
            console.log();
            console.log();
            let str = `产品货号：${this.form.productNo}\n产品名称：${this.form.name}\n产品规格：${this.getCopyInfo('specification')}\n产品价格：${this.getCopyInfo('price')}\n产品链接：https://www.yujiebio.com/ProductDetail?id=${this.id}`
            navigator.clipboard.writeText(str).then(() => {
                this.$message({
                    duration: 1500,
                    type: 'success',
                    message: '一键复制产品信息成功',
                });
            }).catch((error) => {
            });
        },
        changeImg(item, index) {
            if (this.imgIndex == index) {
                return
            }
            this.imgIndex = index
        },
        getElementHeight() {
            const container = this.$refs.detail;
            const container2 = this.$refs.infoBoxRight;
            if (container) {
                this.height = container.offsetHeight
            }
            if (container2) {
                this.width = container2.offsetWidth
            }
        },
    }
}
</script>
<style scoped lang="less">
@media (max-width: 768px) {
    .page {
        padding: 0 0 0 !important;
        box-sizing: border-box !important;

        .header {
            width: 100% !important;
            height: 40px !important;
            padding: 0 10px !important;

            .navbar {
                .navbarItem {
                    font-size: 12px !important;
                }
            }

            .companyName {
                display: none;
            }

            img {
                width: 30% !important;
            }
        }

        .detail {
            margin-top: 0 !important;
            padding: 0 10px !important;

            .infoBox {
                gap: 10px !important;

                .infoBoxLeft {
                    width: 100px !important;
                    height: 100px !important;
                    border-radius: 8px !important;

                    .nowImg {
                        height: 100px !important;
                    }
                }

                .infoBoxRight {
                    .skuList {
                        width: 100%;
                        margin: 0 0 10px !important;
                        padding: 0 !important;
                        box-sizing: border-box;

                        .skuHeader {
                            box-sizing: border-box;
                            font-size: 12px !important;

                            div {
                                text-align: center !important;
                            }
                        }

                        .skuCol {
                            box-sizing: border-box;
                            font-size: 12px !important;

                            div {
                                text-align: center !important;
                            }
                        }
                    }

                    .pName {
                        font-size: 12px !important;
                    }

                    .pNum {
                        font-size: 12px !important;
                    }

                    .price {
                        font-size: 12px !important;
                    }

                    .spec {
                        margin-bottom: 10px !important;

                        .title {
                            font-size: 12px !important;
                        }

                        .specTxt {
                            font-size: 12px !important;
                        }
                    }

                    .imgList {
                        .imgItem {
                            width: 50px !important;
                            height: 50px !important;
                        }
                    }

                    .btn {
                        width: 120px !important;
                        height: 30px !important;
                        line-height: 30px !important;
                        font-size: 12px !important;
                        border-radius: 4px !important;
                    }
                }
            }

            .mainTitle {
                font-size: 16px !important;
            }
        }

        .option {
            margin: 5px 0 !important;
            padding: 0 10px !important;
        }
    }
}
</style>
<style scoped lang="less">
.page {
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    word-break: break-all;
    padding: 0 0 0;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;

    .header {
        padding: 0 150px;
        background-color: #fff;
        width: 100%;
        height: 80px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        .companyName {
            margin-left: 10px;
            width: 250px;
        }

        .logo {
            width: 160px;
        }

        .navbar {
            display: flex;

            .navbarItem:hover {
                color: #2d62ff;
            }

            .navbarItem {
                margin-left: 32px;
                font-size: 17px;
                color: #1f2939;
                cursor: pointer;
                font-weight: 500;
            }
        }
    }

    .productContent {
        width: 100%;

        img {
            display: block;
            margin: 10px auto;
            max-width: 100%;
            height: auto;
        }
    }

    .detail::-webkit-scrollbar {
        display: none;
    }

    .detail {
        width: 100%;
        flex: 1;
        // height: calc(100vh - 150px);
        overflow: hidden;
        overflow-y: scroll;
        padding: 0 150px;
        box-sizing: border-box;

        .infoBox {
            width: 100%;
            display: flex;
            gap: 32px;
            align-items: center;

            .infoBoxLeft {
                width: 400px;
                height: 400px;
                border-radius: 8px;
                cursor: pointer;
                border: 1px solid #e5e7eb;
                display: flex;
                justify-content: center;
                overflow: hidden;

                .nowImg {
                    height: 400px;
                    width: auto;
                    max-width: 100%;
                    object-fit: contain;
                }
            }

            .infoBoxRight {
                flex: 1;
                display: flex;
                flex-direction: column;
                // justify-content: space-between;
                gap: 10px;

                .skuList {
                    width: 100%;
                    padding: 0 300px 0 0;
                    box-sizing: border-box;

                    .skuHeader {
                        display: flex;
                        align-items: center;
                        padding: 10px 0;
                        box-sizing: border-box;

                        div {
                            text-align: left;
                            flex: 1;
                        }
                    }

                    .skuCol {
                        display: flex;
                        align-items: center;
                        padding: 10px 0;
                        box-sizing: border-box;

                        div {
                            text-align: left;
                            flex: 1;
                        }
                    }
                }

                .btn {
                    width: 200px;
                    height: 36px;
                    text-align: center;
                    line-height: 36px;
                    background-color: #3b66ff;
                    color: #fff;
                    font-size: 14px;
                    font-weight: 500;
                    border-radius: 4px;
                    box-sizing: border-box;
                    cursor: pointer;
                }

                .imgList::-webkit-scrollbar {
                    display: none;
                }

                .imgList {
                    overflow: hidden;
                    overflow-x: scroll;
                    white-space: nowrap;

                    .imgItemActive {
                        border: 1px solid #3b66ff !important;
                    }

                    .imgItem {
                        width: 78px;
                        height: 78px;
                        border: 1px solid #e5e7eb;
                        border-radius: 8px;
                        margin-right: 8px;
                        display: inline-block;
                        cursor: pointer;
                        box-sizing: border-box;
                    }
                }

                .spec {
                    border: 1px solid #e5e7eb;
                    border-radius: 8px;
                    padding: 16px;
                    box-sizing: border-box;

                    .title {
                        font-weight: 600;
                        font-size: 18px;
                        margin-bottom: 12px;
                    }
                }

                .price {
                    font-size: 30px;
                    color: #3b66ff;
                    font-weight: 600;
                }

                .pNum {
                    font-size: 20px;
                    color: #6c7280;

                    span {
                        color: #000;
                    }
                }

                .pName {
                    font-size: 24px;
                    font-weight: 600;
                }
            }
        }

        .mainTitle {
            font-size: 20px;
            font-weight: 600;
            padding: 24px 0;
            box-sizing: border-box;
        }
    }

    .option {
        padding: 24px 150px;
        box-sizing: border-box;
    }
}
</style>